import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User confirmed the plan upgrade on the checkout page',
  name: 'plan_upgrade_confirmed',
  params: [
    {
      description: 'Current plan the user is on',
      name: 'old_plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Plan the user upgraded to',
      name: 'new_plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Billing cycle type',
      name: 'plan_type',
      required: true,
      type: 'enum',
      values: ['monthly', 'annual', 'quarter', 'semiAnnual'],
    },
  ],
};

export default META;
